export var EPurchaseOrderStatus;
(function (EPurchaseOrderStatus) {
    EPurchaseOrderStatus["ACCEPTED"] = "ACCEPTED";
    EPurchaseOrderStatus["REJECTED"] = "REJECTED";
    EPurchaseOrderStatus["CANCELLED"] = "CANCELLED";
    EPurchaseOrderStatus["AMO"] = "AMO";
})(EPurchaseOrderStatus || (EPurchaseOrderStatus = {}));
export var EPurchaseTxnType;
(function (EPurchaseTxnType) {
    EPurchaseTxnType["FP"] = "FP";
    EPurchaseTxnType["AP"] = "AP";
    EPurchaseTxnType["R"] = "R";
    EPurchaseTxnType["SIP"] = "SIP";
    EPurchaseTxnType["XSIP"] = "XSIP";
})(EPurchaseTxnType || (EPurchaseTxnType = {}));
export var EPurchaseOrderType;
(function (EPurchaseOrderType) {
    EPurchaseOrderType["Fresh"] = "Fresh";
    EPurchaseOrderType["Modify"] = "Modify";
    EPurchaseOrderType["Cancel"] = "Cancel";
})(EPurchaseOrderType || (EPurchaseOrderType = {}));
export var EPurchaseSchemePlan;
(function (EPurchaseSchemePlan) {
    EPurchaseSchemePlan["DIRECT"] = "Direct";
    EPurchaseSchemePlan["REGULAR"] = "Regular";
})(EPurchaseSchemePlan || (EPurchaseSchemePlan = {}));
export var EPurchaseSchemeCode;
(function (EPurchaseSchemeCode) {
    EPurchaseSchemeCode["SCHEMECODE"] = "schemeCode";
})(EPurchaseSchemeCode || (EPurchaseSchemeCode = {}));
